<template>
  <v-container grid-list-md fluid>
    <v-layout align-center justify-space-around wrap>
      <v-flex md12>

        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>Templates</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card v-if="template">
          <v-card-title>
            <v-btn text icon color="primary" @click.prevent="openTemplatesPage()"> 
              <v-icon dark>arrow_back</v-icon>
            </v-btn>
            <h4> {{ templateid }} </h4>
            <v-spacer></v-spacer>
            <v-btn small text color="primary" :loading="snack" :disabled="snack || approved" @click.prevent="confirmDelete = true">
              <v-icon dark left>delete</v-icon>
              Delete
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-layout wrap>
            <v-flex md6>
              <v-simple-table dense>
                <tbody>
                  <tr>
                    <td>ID</td>
                    <td colspan="2">{{ template.templateid }}</td>
                  </tr>
                  <tr>
                    <td>Type</td>
                    <td> {{ deviceTypeToString(template.type) }}</td>
                    <td style="text-align: right;">
                      <v-btn x-small text @click.prevent="xkey = 'Type'; tdialog = true" :disabled="approved">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td>OS</td>
                    <td>{{ template.os }}</td>
                    <td style="text-align: right;">
                      <v-btn x-small text @click.prevent="xkey = 'OS'; xvalue = template.os; xdialog = true" :disabled="approved">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td>Description</td>
                    <td>{{ template.description }}</td>
                    <td style="text-align: right;">
                      <v-btn x-small text @click.prevent="xkey = 'Description'; xvalue = template.description; xdialog = true" :disabled="approved">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Base Image</td>
                    <td> {{ template.baseimage }}</td>
                    <td style="text-align: right;">
                      <v-btn x-small text @click.prevent="xkey = 'BaseImage'; udialog = true" :disabled="approved">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Source Image</td>
                    <td> {{ template.sourceimage }}</td>
                    <td style="text-align: right;">
                      <v-btn x-small text @click.prevent="xkey = 'SourceImage'; udialog = true" :disabled="approved">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr v-if="template.os.includes('ARM')">
                    <td style="white-space: nowrap">Install Image</td>
                    <td> {{ template.installimage }}</td>
                    <td style="text-align: right;">
                      <v-btn x-small text @click.prevent="xkey = 'InstallImage'; udialog = true" :disabled="approved">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr v-if="template.os.includes('CentOS') || template.os.includes('Rocky') || template.os.includes('AlmaLinux')">
                    <td>Kickstart</td>
                    <td colspan="2">{{ filename(template.kickstart) }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Build Script</td>
                    <td colspan="2">{{ filename(template.buildscript) }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Dep Resolver</td>
                    <td colspan="2">{{ filename(template.depresolver) }}</td>
                  </tr>
                  <tr>
                    <td>PostInstall</td>
                    <td colspan="2">{{ filename(template.postinstall) }}</td>
                  </tr>
                  <tr>
                    <td>Packages</td>
                    <td>{{ prettyPackages(template.packagesList) }}</td>
                    <td style="text-align: right;">
                      <v-btn x-small text @click.prevent="xkey = 'Packages'; xvalue = prettyPackages(template.packagesList); xdialog = true" :disabled="approved">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">On-Demand Packages</td>
                    <td>{{ prettyPackages(template.ondemandpackagesList) }}</td>
                    <td style="text-align: right;">
                      <v-btn x-small text @click.prevent="xkey = 'OnDemandPackages'; xvalue = prettyPackages(template.ondemandpackagesList); xdialog = true" :disabled="approved">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Optional SVN Files</td>
                    <td>{{ prettyPackages(template.optionalsvnfilesList) }}</td>
                    <td style="text-align: right;">
                      <v-btn x-small text @click.prevent="xkey = 'OptionalSvnFiles'; xvalue = prettyPackages(template.optionalsvnfilesList); xdialog = true" :disabled="approved">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td>Owner</td>
                    <td colspan="2">{{ template.owner }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Last Modified</td>
                    <td colspan="2">{{ dateToString(template.lastmodified) }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Modified By</td>
                    <td colspan="2">{{ template.modifiedby }}</td>
                  </tr>
                  <tr>
                    <td>Approved</td>
                    <td colspan="2">
                      <input type="checkbox" v-model="approved" :loading="snack" :disabled="snack || !aaaaccess(user)" v-on:change="callApproveTemplate()">
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-flex>

            <v-flex md6>
              <v-card>
                <!-- <v-card-title>Info</v-card-title> -->
                <v-card-text>
                  <p>
                    <ul>
                      <li>Supported Type is <b>PAC</b> or <b>SCADA</b>.</li>
                      <li>Supported OS is <b>CentOS 7</b>, <b>Rocky Linux 8</b>, <b>Rocky Linux 9</b>, <b>AlmaLinux 9</b>, <b>AlmaLinux 10</b>, <b>Debian 9 ARMEL</b>, <b>Debian 9 ARMHF</b>, <b>Debian 9 ARMHF WAGO</b>, <b>Debian 11 ARM64</b> or <b>Debian 12 ARM64</b>.</li>
                      <li>Base image is used to create the final image.</li>
                      <li>Source image is used to source additional packages, must match worker configuration.</li>
                      <li v-if="template.os.includes('ARM')">Install image is used for installation.</li>
                      <li>Packages is a space separated list of required packages for this template.</li>
                      <li>On-Demand Packages is a space separated list of packages that are installed only on demand by scripts for this template.</li>
                      <li>Optional SVN Files is a space separated list of files that if exists, will be available to scripts for this template.</li>
                      <li>Post Install script will run as a service on first boot.</li>
                      <li>Build script is used to create final image.</li>
                      <li>Dependency Resolver script is used to resolve package dependencies.</li>
                      <li v-if="aaaaccess(user)">
                        Template files can be found and modified at
                        <a :href="'https://console.cloud.google.com/storage/browser/'+getBucketName()+'/templates/'+templateid+'/'" target="_blank">gs://{{getBucketName()}}/templates/{{ templateid }}</a>
                      </li>
                    </ul>
                  </p>
                  <p>
                    Packages for PAC (TEL3 & CPROC) and SCADA (Unity Release) are automatically added. <b class="red--text text--lighten-1">Do not add here, it will break dependencies.</b>
                  </p>
                  <div class="red--text text--lighten-1" v-if="!isTemplateComplete()"> {{ templateComplete }} </div> <br />
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="xdialog"
      width="500"
      v-if="template"
    >
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-textarea
            v-model="xvalue"
            :label="xkey"
            auto-grow
            solo
            background-color="rgba(0, 0, 0, .02)"
            flat
            counter="4096"
            dense
            :readonly="approved"
            v-if="xkey == 'Packages' || xkey == 'OnDemandPackages' || xkey == 'OptionalSvnFiles'"
          ></v-textarea>
          <v-text-field
            v-model="xvalue"
            :label="xkey"
            required
            v-else
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.prevent="xdialog = false">Close</v-btn>
          <v-btn color="primary" text @click.prevent="callUpdateTemplate()" :disabled="snack || approved">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="udialog"
      width="500"
      v-if="template"
    >
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="xvalue"
            :items="getUpstreamImages()"
            :loading="isLoading.upstream"
            clearable
            :label="xkey"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.prevent="udialog = false">Cancel</v-btn>
          <v-btn color="primary" text @click.prevent="callUpdateTemplate()">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="tdialog"
      width="500"
      v-if="template"
    >
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="xvalue"
            :items="getTypes()"
            clearable
            label="Type"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.prevent="tdialog = false">Cancel</v-btn>
          <v-btn color="primary" text @click.prevent="callUpdateTemplate()">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="confirmDelete"
      width="500"
    >
      <v-card>
        <v-card-title>Delete selected template?</v-card-title>
        <v-card-text>
          "{{ templateid }}" will be deleted. You can't undo this action.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.prevent="confirmDelete = false">Cancel</v-btn>
          <v-btn color="primary" text @click.prevent="callDeleteTemplate(); confirmDelete = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog"
      persistent
      width="500"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTimeout"
      :top="true"
    >
      {{ snackMessage }}
      <v-btn
        text
        @click="snack = false"
      >
        <div class="v-menu__content--active" style="display:none; z-index:1000;"></div>
        Close
      </v-btn>
    </v-snackbar>

  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import libvue from '@/lib/vue.js'

export default {
    mixins: [libvue],
    data() {
    return {
      templateid: this.$route.params.TemplateID,
      confirmDelete: false,
      dialog: false,
      udialog: false,
      tdialog: false,
      xdialog: false,
      xkey: null,
      xvalue: null,
      templateComplete: "unknown",
      snack: false,
      snackColor: 'primary',
      snackMessage: '',
      snackTimeout: 1000
    }
  },
  components: {},
  mounted() {
  },
  created() {
    this.filterTemplates();
    this.filterUpstream();
  },
  computed: {
    template: {
      get() {
        return this.allTemplates[this.templateid];
      }
    },
    approved: {
      get() {
        return this.template.approved;
      },
      set(v) {
        this.template.approved = v;
      },
    },
    ...mapGetters(['allTemplates', 'allUpstream', 'user', 'isLoading'])
  },
  methods: {
    openTemplatesPage() {
      this.$router.push({ name: 'templates' });
    },
    callUpdateTemplate() {
      this.dialog = true;
      var t = Object.assign({}, this.template);
        switch (this.xkey) {
          case 'OS':
            t.os = this.xvalue;
            break;
          case 'Description':
            t.description = this.xvalue;
            break;
          case 'BaseImage':
            t.baseimage = this.xvalue;
            break;
          case 'SourceImage':
            t.sourceimage = this.xvalue;
            break;
          case 'InstallImage':
            t.installimage = this.xvalue;
            break;
          case 'Type':
            // eslint-disable-next-line no-undef
            if (this.xvalue == this.deviceTypeToString(proto.pb.DeviceType.DEVICEPAC)) {
              // eslint-disable-next-line no-undef
              t.type = proto.pb.DeviceType.DEVICEPAC;
            }
            // eslint-disable-next-line no-undef
            if (this.xvalue == this.deviceTypeToString(proto.pb.DeviceType.DEVICESCADA)) {
              // eslint-disable-next-line no-undef
              t.type = proto.pb.DeviceType.DEVICESCADA;
            }
            break;
          case 'Packages':
            var list = [];
            this.xvalue.split(" ").sort().forEach((v) => {
              list.push(v);
            });
            t.packagesList = [...new Set(list)];
            break;
          case 'OnDemandPackages':
            var slist = [];
            this.xvalue.split(" ").sort().forEach((v) => {
              slist.push(v);
            });
            t.ondemandpackagesList = [...new Set(slist)];
            break;
          case 'OptionalSvnFiles':
            var vlist = [];
            this.xvalue.split(" ").sort().forEach((v) => {
              vlist.push(v);
            });
            t.optionalsvnfilesList = [...new Set(vlist)];
            break;
        }
        this.updateTemplate(t).then(() => {
          this.dialog = false;
          this.xdialog = false;
          this.udialog = false;
          this.tdialog = false;
          this.snack = true;
          this.snackColor = 'success';
          this.snackMessage = "Template updated";
          this.filterTemplates().then(() => {});
        }).catch((err) => {
          this.dialog = false;
          this.xdialog = false;
          this.udialog = false;
          this.tdialog = false;
          this.snack = true;
          this.snackColor = 'error';
          this.snackMessage = this.errToString(err);
        });
    },
    callDeleteTemplate() {
      this.dialog = true;
      var t = Object.assign({}, this.template);
      this.deleteTemplate(t).then(() => {
          this.dialog = false;
          this.xdialog = false;
          this.snack = true;
          this.snackColor = 'success';
          this.snackMessage = "Template deleted";
          this.openTemplatesPage();
        }).catch((err) => {
          this.dialog = false;
          this.xdialog = false;
          this.snack = true;
          this.snackColor = 'error';
          this.snackMessage = this.errToString(err);
        });
    },
    callApproveTemplate() {
      if (this.approved && !this.isTemplateComplete()) {
        this.snack = true;
        this.snackColor = 'error';
        this.snackMessage = "Template is incomplete";
        this.filterTemplates().then(() => {});
        return;
      }
      this.dialog = true;
      var t = Object.assign({}, this.template);
      this.approveTemplate(t).then(() => {
          this.dialog = false;
          this.xdialog = false;
          this.snack = true;
          this.snackColor = 'success';
          this.snackMessage = "Template updated";
        }).catch((err) => {
          this.dialog = false;
          this.xdialog = false;
          this.snack = true;
          this.snackColor = 'error';
          this.snackMessage = this.errToString(err);
        });
    },
    getTypes() {
      var types = [];
      // eslint-disable-next-line no-undef
      types.push(this.deviceTypeToString(proto.pb.DeviceType.DEVICEPAC));
      // eslint-disable-next-line no-undef
      types.push(this.deviceTypeToString(proto.pb.DeviceType.DEVICESCADA));
      return types;
    },
    getUpstreamImages() {
      var up = [];
      Object.values(this.allUpstream).forEach((o) => {
        up.push(o.name);
      });
      return up;
    },
    isTemplateComplete() {
      if (!this.template) {
        this.templateComplete = "No template found";
        return false;
      }
      if (!this.template.baseimage || this.template.baseimage == "") {
        this.templateComplete = "Base image is required";
        return false
      }
      if (!this.template.sourceimage || this.template.sourceimage == "") {
        this.templateComplete = "Source image is required";
        return false
      }
      if (this.template.os.includes('ARM') && (!this.template.installimage || this.template.installimage == "")) {
        this.templateComplete = "Install image is required";
        return false
      }
      if (!this.template.type || (this.deviceTypeToString(this.template.type) == "None" || this.deviceTypeToString(this.template.type) == "UNKNOWN")) {
        this.templateComplete = "Type is required";
        return false
      }
      return true;
    },
    ...mapActions(['filterTemplates', 'updateTemplate', 'deleteTemplate', 'approveTemplate', 'filterUpstream'])
  }
}
</script>
